import { render, staticRenderFns } from "./list-claim.vue?vue&type=template&id=737e72bc"
import script from "./list-claim.vue?vue&type=script&lang=js"
export * from "./list-claim.vue?vue&type=script&lang=js"
import style0 from "./list-claim.vue?vue&type=style&index=0&id=737e72bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports